import { Component } from '@angular/core';

@Component({
  selector: 'pc-full-logo',
  standalone: true,
  imports: [],
  templateUrl: './full-logo.component.html',
  styleUrl: './full-logo.component.scss'
})
export class FullLogoComponent {

}
